import moment from 'moment';
import React, { FC } from 'react';
import {
  DATE_INPUT_DISPLAY_FORMAT,
  DateType,
  DEFAULT_DATE_FORMAT,
} from 'api/models';
import { BaseCell } from 'components/organisms/timesheets/common/timesheet-table';

export const DateCell: FC<{ date?: DateType }> = ({ date }) => (
  <BaseCell>
    {date != null
      ? moment(date, DEFAULT_DATE_FORMAT).format(DATE_INPUT_DISPLAY_FORMAT)
      : '-'}
  </BaseCell>
);
